<template>
  <div id="material-kit">
    <div :class="{ 'nav-open': NavbarStore.showNavbar }">
      <login-dialog />
      <router-view name="header" />
      <div>
        <router-view />
      </div>
      <router-view name="footer" />
    </div>
  </div>
</template>

<script>
import LoginDialog from "./views/components/LoginDialog.vue";

export default {
  created() {},
  components: { LoginDialog },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    location() {
      function successCallback(position) {}
      function errorCallback(error) {}

      navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
      var watchId = navigator.geolocation.watchPosition(successCallback);
      navigator.geolocation.clearWatch(watchId);
    }
  }
};
</script>
<style>
.w-100 {
  width: 100% !important;
}
body {
  font-family: "Readex Pro";
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-20 {
  margin-left: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mr-5 {
  margin-right: 5px;
}
.mt-5 {
  margin-top: 5px;
}
.mb-5 {
  margin-bottom: 5px;
}
.ml-5 {
  margin-left: 5px;
}

.pr-10 {
  padding-right: 10px;
}
.pl-10 {
  padding-left: 10px;
}
.pt-10 {
  padding-top: 10px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pr-20 {
  padding-right: 20px;
}
.pl-20 {
  padding-left: 20px;
}
.pb-20 {
  padding-bottom: 20px;
}
.pt-20 {
  padding-top: 20px;
}
.pr-5 {
  padding-right: 5px;
}
.pt-5 {
  padding-top: 5px;
}
.pb-5 {
  padding-bottom: 5px;
}
.pl-5 {
  padding-left: 5px;
}
.px-10 {
  padding: 0 10px !important;
}
.px-15 {
  padding: 0 15px !important;
}
.px-20 {
  padding: 0 20px !important;
}
.mx-10 {
  margin: 0 10mx !important;
}
.mx-15 {
  margin: 0 15px !important;
}
.mx-20 {
  margin: 0 20px !important;
}
.flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.c-main {
  color: #035ae0;
}
.c-white {
  color: #ffff;
}
.text-center {
  text-align: center;
}
.justify-center {
  justify-content: center !important;
}
.justify-space-between {
  justify-content: space-between !important;
}
.justify-flex-end {
  justify-content: flex-end;
}
.justify-flex-start {
  justify-content: flex-start;
}
.align-start {
  align-items: start;
}
.colum {
  flex-direction: column !important;
}
.flex-shrink {
  flex-shrink: 0;
}
.align-center {
  align-items: center !important;
}
.m-0 {
  margin: 0;
}
.p-0 {
  padding: 0;
}
.c-tiny {
  font-size: 12px;
}
.c-caption {
  font-size: 14px;
}
.c-body2 {
  font-size: 16px;
}
.c-body1 {
  font-size: 18px;
}
.c-title2 {
  font-size: 20px;
}
.c-title1 {
  font-size: 24px;
}
.c-body2 {
  font-size: 16px;
}
.c-h5 {
  font-size: 20px;
}
.c-h4 {
  font-size: 24px;
}
.c-h3 {
  font-size: 30px;
}
.c-h2 {
  font-size: 36px;
}
.c-h1 {
  font-size: 72px;
}
.c-error-text {
  color: red;
}

.pointer {
  cursor: pointer;
}

.fw-300 {
  font-weight: 300;
}
.fw-400 {
  font-weight: 400;
}
.fw-500 {
  font-weight: 500;
}
.fw-600 {
  font-weight: 600;
}
.fw-700 {
  font-weight: 700;
}

.float-right {
  float: right;
}
.mb-0 {
  margin-bottom: 0;
}
.c-icon {
  color: #c0c4cc;
}
.el-rate__icon {
  margin-right: 5px !important;
}

.span-answer img {
  height: 80px !important;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 9px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #9d9c9c;
  border-radius: 6px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #9d9c9c;
  border-radius: 6px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #9d9c9c;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.desktop {
  display: block;
}
.mobile {
  display: none;
}
 .el-message-box__btns {
    text-align: center !important;
  }
@media screen and (min-width: 0px) and (max-width: 769px) {
  .el-autocomplete-suggestion {
    width: 300px !important;
    left: 50px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .el-message-box {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 380px !important;
  }
 
}
</style>
